import React from 'react'
import {
    Grid,
    Typography,
    Container,
} from '@material-ui/core'
import { VideoPlayer, VideoRecorder } from 'salvatores'
import 'salvatores/dist/index.css'
import {
    ArrowBack,
    VideoCall
} from '@material-ui/icons'
import { CustomAppBar, CustomButton } from '../../../shared'
import { AddressProofFrame } from '../../../assets/images'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'
import { isObject } from 'lodash'
import { HomeVideo } from '../../../assets/videos'

const Video = ({ goBack, goToScreen, language, languageJSON, step, video, submit, onRecordingComplete, 
    constraints, isCameraOn, handleChange }) => {
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_home_video')}
                leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
                rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'video' })} label={supportedLanguageMapping[language]} />} />
            {step === 1 ?
                <Container style={{ padding: 0 }}>
                    <Grid container justify="center" alignItems="center" spacing={4} style={{ paddingBottom: 50, maxHeight: '70vh', overflow: 'scroll' }}>
                        <Grid item xs={11}>
                            <Typography variant="body1">
                                {getContent(languageJSON, 'subtitle_preview_example_video')}
                            </Typography>
                        </Grid>
                        <Grid item xs={11}>
                            <VideoPlayer url={HomeVideo} />
                        </Grid>
                    </Grid>
                </Container>
                : null}
            {
                step === 2 ?
                    <Container>
                        <Grid container justify="center" spacing={4} style={{ maxHeight: '100vh', overflow: 'scroll', paddingBottom: 130 }}>
                            <Grid item xs={11}>
                                <VideoPlayer url={isObject(video) ? video.videoUrl : video} />

                                <div style={{ margin: '5%' }}>
                                    <VideoRecorder
                                        frameHeight={600}
                                        frame={AddressProofFrame}
                                        constraints={constraints}
                                        cameraStateChange={(value) => handleChange('isCameraOn', value)}
                                        countDown={30}
                                        content={
                                            <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="secondary" 
                                                label={<Grid container alignItems="center" justify="center">
                                                    <VideoCall style={{ marginRight: 5 }} />
                                                    <Typography style={{ fontSize: 12 }}>{getContent(languageJSON, 'action_retake_video')}</Typography>
                                                </Grid>} />
                                        }
                                        onRecordingComplete={onRecordingComplete} />
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                    : null
            }
            {
                step === 1 ?
                    <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: !isCameraOn ? 'absolute' : '', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                        <Grid item xs={11}>
                            <VideoRecorder
                                frameHeight={600}
                                frame={AddressProofFrame}
                                constraints={constraints}
                                cameraStateChange={(value) => handleChange('isCameraOn', value)}
                                countDown={30}
                                content={
                                    <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="primary" 
                                    label={
                                        <Grid container alignItems="center" justify="center">
                                            <VideoCall style={{ marginRight: 5 }} />
                                            <Typography variant="button">{getContent(languageJSON, 'action_cature_video')}</Typography>
                                        </Grid>} />
                                }
                                onRecordingComplete={onRecordingComplete} />
                        </Grid>
                    </Grid> : <Grid container justify="center" alignItems="center" style={{ padding: '15px', position: 'absolute', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                        <Grid item xs={11}>
                            <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%', fontSize: 12 }} color="primary" 
                                label={<Typography variant="button">{getContent(languageJSON, 'action_submit_video')}</Typography>} handleChange={submit} />
                        </Grid>
                    </Grid>
            }
        </div >
    )
}

export default Video